<template>
  <element>
    <v-icon
      :x-small="size === 'x-small'"
      :small="size === 'small'"
      :medium="size === 'medium'"
      :large="size === 'large'"
      :x-large="size === 'x-large'"
      v-clipboard="text"
      v-clipboard:success="clipboardSuccessHandler"
      v-clipboard:error="clipboardErrorHandler"
    >
      mdi-checkbox-multiple-blank-outline
    </v-icon>
    <v-snackbar
      v-model="showNotification"
      class="notification"
      top
      :timeout="timeout"
      :color="color"
      width="150"
    >
      {{ copySuccessful ? $t('notification.clipboardSuccess') : $t('notification.clipboardFailure') }}
    </v-snackbar>
  </element>
</template>

<script>
export default {
  name: "CopyButton",
  props: {
    text: {
      type: String,
      default: ''
    },
    timeout: {
      type: Number,
      default: 1000
    },
    color: {
      type: String,
      default: "rgba(47, 47, 47, 0.7)"
    },
    size: {
      type: String,
      default: 'small'
    },
    copySuccessful: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showNotification: false
    }
  },
  methods: {
    clipboardSuccessHandler ({ value, event }) {
      this.copySuccessful = true
      this.showNotification = true
      localStorage.setItem('textClipboard', this.text)
      console.log('success', value, event)
    },
    clipboardErrorHandler ({ value, event }) {
      this.copySuccessful = false
      this.showNotification = true
      console.log('error', value, event)
    },
  }
}
</script>

<style scoped>
.notification {
  margin-top: 6rem;
}

@media screen and (max-width: 600px) {
  .notification {
    margin-top: 5rem;
  }
}
</style>